import React, { useMemo, useRef, useState } from 'react';

import { DropDownOptions } from 'devextreme-react/cjs/select-box';
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import ValidationGroup from 'devextreme-react/validation-group';

import { AppCol, AppFieldBox, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ClaimsProvider from 'components/claimsBlock';
import { useAuth } from 'context/auth';
import { Button, DateBox, NumberBox, SelectBox, TextArea, Validator } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';
import $createDataSource from 'utils/create-data-souce-instance';

import { NomenclatureTransfer } from 'bus/nomenclatureTransfer/types';

import { NOMENCLATURE_TRANSFER_DEFAULT_FORM } from '../../NomenclatureTransfer.constants';

type Props = {
  onSubmit: (data: NomenclatureTransfer) => void;
  dataNomenclatureTransfer?: NomenclatureTransfer | undefined;
  loading: boolean;
};

export const NomenclatureTransferForm = ({ onSubmit, dataNomenclatureTransfer, loading }: Props) => {
  const ref = useRef<ValidationGroup>(null);
  const { getClaims }: any = useAuth();
  const readOnly = !getClaims(['CanEditNomenclatureTransferSection']);

  const factoryDataStore: DataSource = useMemo(() => {
    const defaultFilter = ['parentId', '=', null];
    return $createDataSource('/v1/factory', 'id', { pageSize: 20, paginate: true, defaultFilter });
  }, []);

  const storeMaterial: any = useMemo(() => {
    const defaultFilter = ['ComingNomenclaturePlace', '=', 0];
    return $createDataSource('/v1/Material', 'id', { defaultFilter });
  }, []);

  const unitDataSource: DataSource = useMemo(() => {
    const defaultFilter = [['id', '=', 4], 'or', ['id', '=', 5]];
    return $createDataSource('/v1/unit', 'id', { pageSize: 20, paginate: true, defaultFilter });
  }, []);

  const [form, setForm] = useState<NomenclatureTransfer>(
    dataNomenclatureTransfer || NOMENCLATURE_TRANSFER_DEFAULT_FORM,
  );

  const handleSubmit = () => {
    const isValid = ref.current?.instance.validate().isValid;

    if (isValid && form) onSubmit(form);
  };

  return (
    <div style={{ maxWidth: 800 }}>
      <form onSubmit={handleSubmit}>
        <ValidationGroup ref={ref}>
          <Form formData={form}>
            <Item colSpan={12} colCount={12} itemType="group">
              <AppFieldBox label="Откуда" labelTop>
                <SelectBox
                  stylingMode="underlined"
                  readOnly={readOnly}
                  dataSource={factoryDataStore}
                  //items={factoryData}
                  displayExpr="name"
                  valueExpr="id"
                  value={form.sourceFactoryId}
                  onItemClick={(e) => {
                    setForm((prev) => ({ ...prev, sourceFactoryId: e.itemData.id }));
                  }}
                >
                  <DropDownOptions title="Выберите поле откуда" closeOnOutsideClick={true} showTitle={false} />
                  <Validator>
                    <RequiredRule message="Выберите поле откуда" />
                  </Validator>
                </SelectBox>
              </AppFieldBox>

              <AppFieldBox label="Дата" labelTop>
                <DateBox
                  readOnly={readOnly}
                  stylingMode="underlined"
                  type="date"
                  onValueChange={(e) => {
                    setForm((prev) => ({ ...prev, date: e as string }));
                  }}
                  useMaskBehavior
                  dateSerializationFormat="yyyy-MM-ddTHH:mm:ssx"
                  value={form.date}
                >
                  <Validator>
                    <RequiredRule message="Заполните поле дата" />
                  </Validator>
                </DateBox>
              </AppFieldBox>

              <AppFieldBox label="Куда" labelTop>
                <SelectBox
                  readOnly={readOnly}
                  stylingMode="underlined"
                  dataSource={factoryDataStore}
                  //items={factoryData}
                  displayExpr="name"
                  valueExpr="id"
                  value={form.destinationFactoryId}
                  onItemClick={(e) => {
                    setForm((prev) => ({ ...prev, destinationFactoryId: e.itemData.id }));
                  }}
                >
                  <DropDownOptions title="Выберите поле куда" closeOnOutsideClick={true} showTitle={false} />
                  <Validator>
                    <RequiredRule message="Выберите поле куда" />
                  </Validator>
                </SelectBox>
              </AppFieldBox>
              <AppRow>
                <AppCol col={6}>
                  <AppFiledBox label="Материал" labelTop>
                    <SelectBox
                      readOnly={readOnly}
                      stylingMode="underlined"
                      dataSource={storeMaterial}
                      displayExpr="name"
                      valueExpr="id"
                      value={form.nomenclatureId}
                      onItemClick={(e) => {
                        setForm((prev) => ({ ...prev, nomenclatureId: e.itemData.id }));
                      }}
                    >
                      <DropDownOptions title="Выберите Материал" closeOnOutsideClick={true} showTitle={false} />
                      <Validator>
                        <RequiredRule message="Выберите Материал" />
                      </Validator>
                    </SelectBox>
                  </AppFiledBox>
                </AppCol>
                <AppCol col={6}>
                  <AppFieldBox label="Ед. изм." labelTop>
                    <div className="d-flex align-center">
                      <SelectBox
                        readOnly={readOnly}
                        stylingMode="underlined"
                        style={{ width: '100%' }}
                        dataSource={unitDataSource}
                        displayExpr="name"
                        valueExpr="id"
                        value={form.unitId}
                        onValueChange={(e) => {
                          setForm((prev) => ({ ...prev, unitId: e }));
                        }}
                      >
                        <DropDownOptions title="Выберите Ед. изм." closeOnOutsideClick={true} showTitle={false} />
                        <Validator>
                          <RequiredRule message="Выберите Ед. изм." />
                        </Validator>
                      </SelectBox>
                    </div>
                  </AppFieldBox>
                </AppCol>
              </AppRow>

              <AppFiledBox label="Цена за рейс" labelTop>
                <NumberBox
                  readOnly={readOnly}
                  stylingMode="underlined"
                  placeholder="Введите Цена за рейс"
                  format="###0.##"
                  value={form.driverSalary}
                  onValueChanged={(e) => {
                    setForm((prev) => ({ ...prev, driverSalary: e.value }));
                  }}
                >
                  <Validator>
                    <RequiredRule message="Заполните поле Цена за рейс" />
                  </Validator>
                </NumberBox>
              </AppFiledBox>
              <AppFieldBox label="Комментарий" labelTop>
                <TextArea
                  readOnly={readOnly}
                  stylingMode="underlined"
                  placeholder="Введите комментарий"
                  mode="text"
                  value={form.comment || ''}
                  onChange={(e: any) => {
                    setForm((prev) => ({ ...prev, comment: e.event.currentTarget.value }));
                  }}
                />
              </AppFieldBox>
              <ClaimsProvider claimsBlock={['CanEditNomenclatureTransferSection']}>
                <div className="d-flex justify-end mt-1">
                  <Button
                    text="Сохранить"
                    type="success"
                    useSubmitBehavior={false}
                    //@ts-ignore
                    onClick={handleSubmit}
                    disabled={loading}
                  />
                </div>
              </ClaimsProvider>
            </Item>
          </Form>
        </ValidationGroup>
      </form>
    </div>
  );
};
